import React, {useEffect} from 'react';
import {BackgroundSaveOn} from "./style";
import {useDispatch, useSelector} from "react-redux";
import {finishLoading, showNavBar, startLoading} from "../../_store/_actions/uiActions";
import HttpClient from "../../_services/httpClient";

const TravelYourWay = () => {

    const dispatch = useDispatch();
    const {partnerId} = useSelector(state => state.repository.user);

    const getData = (url) => {
        return new Promise((resolve, eject) => {
            dispatch(startLoading());
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleSaveOnUrl = (e) => {
        e.preventDefault();

        getData(`/saveonresort/saveonurl/${partnerId}`).then((response) => {
            if (response.status === 200) {
                console.log(response.data);
                window.open(response.data, '_self');
            }
        })

    }

    useEffect(() => {
        dispatch(showNavBar());
    },[])

    return (
        <>
            <BackgroundSaveOn>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="logo nomargin nopadding" />
                    </div>
                    <div className="divcenter">
                        <div className="title-page">
                            <h2>Partners</h2>
                        </div>
                    </div>
                </div>

                <div className="row mt-5 ml-2">
                    <div className="row col-lg-12">
                        <div className="col-lg-3">
                            <div className="title">
                                <h2>LVC Travel Your Way</h2>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <span>In this section of your <b>SHARED ECONOMY Partner Portal</b> you will find everything related to your <b>ECO's, Air ECO's</b> and <b>Cashable USD.</b>
                                Review your ECO's usage history and keep track of your past and future Air ECO's earnings. If you decide to do so, transfer any amount
                                of your Cashable USD balance to pay off your <b>REEF Hotels Membership.</b></span>
                            <br/>
                            <div className="row mt-3">
                                <div className="col_full">

                                    <div className="col-lg-12 d-inline-block d-sm-inline-flex justify-content-start justify-content-lg-end">
                                        <button className="button button-circle button-blue"
                                                onClick={handleSaveOnUrl}>
                                            <i className="icon-map-marker2"></i>
                                            Goto LVC Travel Your Way
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </BackgroundSaveOn>
        </>
    );
};

export default TravelYourWay;
